<template>
    <div class="strategy-list">
        <div class="strategy-opration">

            <el-input placeholder="请输入模型ID" v-model="queryParams.modelId" prefix-icon="el-icon-search"
                      style="width: 350px"></el-input>
            <el-input placeholder="请输入策略币种(符号)" v-model="queryParams.symbol" prefix-icon="el-icon-search"
                      style="width: 250px"></el-input>
            <el-button style="margin-left: 10px" type="danger" @click="searchDignals">搜索</el-button>

        </div>
        <div class="strategy-list">
            <el-table class="strategy-table" border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="dataList" :row-key="() => Math.random()">
                <el-table-column prop="modelId" label="模型id" show-overflow-tooltip></el-table-column>
                <el-table-column prop="signalIntensity" label="信号强度" show-overflow-tooltip></el-table-column>
                <el-table-column prop="strategyName" label="符号" show-overflow-tooltip></el-table-column>
                <el-table-column prop="indexPrice" label="信号产生时指数价" show-overflow-tooltip></el-table-column>
                <el-table-column label="信号生成时间" width="200">
                    <template slot-scope="scope">
                        <span>{{scope.row.generationDate | moment}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="queryParams.page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="queryParams.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import '../store';
    import api from '../api';

    export default {
        name: "historySignals",
        data() {
            return {
                dataList: [], //数据列表
                total: 0, //总条数
                queryParams: { //查询参数
                    symbol: "",
                    strategyId: "",
                    modelId: "",
                    page: 1,
                    size: 10
                }
            }
        },
        computed: {},
        mounted() {
        },
        methods: {
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getSignalPage(this.queryParams);
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getSignalPage(this.queryParams);
            },
            getSignalPage(param) {
                api.getSignalPage(param).then(({data}) => {
                    this.dataList = data.data;
                    this.total = data.total;
                });
            },
            searchDignals() {
                this.queryParams.page = 1;
                this.getSignalPage(this.queryParams);
            }
        },
        created() {
            this.queryParams.strategyId = this.$route.query.id;
            this.getSignalPage(this.queryParams);
        }
    }
</script>

<style type="text/css">
    .strategy-list .el-tabs__nav-wrap::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 2px;
        background-color: rgba(245, 249, 255, 0);
        z-index: 1;
    }
</style>
<style lang="less" scoped>
    .strategy-list {

        .strategy-list {
            border: 1px solid #f2ece2;
            clear: both;
            width: 100%;
            .strategy-table {
                margin-top: 30px;

                .red {
                    color: #EC6D56;
                }
                .blue {
                    color: #406CE9;
                }
                .green {
                    color: #6dec82;
                }
            }
        }
    }
</style>